import { render, staticRenderFns } from "./selectPeo.vue?vue&type=template&id=4331dba1&"
import script from "./selectPeo.vue?vue&type=script&lang=js&"
export * from "./selectPeo.vue?vue&type=script&lang=js&"
import style0 from "./selectPeo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports